var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.params[_vm.field] !== null && _vm.params[_vm.field] !== -1)?_c('img',{staticClass:"battery",attrs:{"src":_vm.icon,"title":_vm.description}}):_c('span',{attrs:{"title":_vm.$t('battery-not-seen-message')}},[_vm._v("-- --")])])}
var staticRenderFns = []

export { render, staticRenderFns }